<template>
  <b-row>
    <b-col sm="12" md="12">
      <b-card no-body>
        <b-card-header>
          <h5 class="float-left"><i class="fa fa-calculator"></i> VIP Level - Payment Option</h5>
          <div class="float-right">
            <b-button 
              v-if="Object.keys(selectedMethod).length !== 0" 
              :variant="isFeatured ? 'danger' : 'success'" 
              class="mr-2" 
              @click="showFeaturePaymentConfirmModal">
              {{ isFeatured ? 'Remove Featured' : 'Feature Payment' }}
            </b-button>
            <b-button variant="primary" @click="showAddPaymentMethodModal">Add Payment Method</b-button>
          </div>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col sm="12" md="2">
              <label>Select Payment Method</label>
              <b-list-group>
                <b-list-group-item @click="selectMethod(val)" :variant="(val.Maintenance === 0) ? val.Color : 'secondary'" :active="selectedMethod.Name === val.Name" href="#" v-for="(val, key) in paymentMethod" :key="key"><i v-if="val.Maintenance === 1" class="fa fa-warning"></i> {{ val.Name }}</b-list-group-item>
              </b-list-group>
            </b-col>
            <b-col sm="12" md="10" v-if="Object.keys(selectedMethod).length !== 0">
              <b-card no-body>
                <b-card-header>
                  <b-row>
                    <b-col sm="9">
                      <h5>{{ selectedMethod.Name }}</h5>
                      <template v-if="checkAccessPrivilege('Payment.Level.Options.Change')">
                        <template v-if="!showUpdateServiceTime">
                          <em>Daily Service Time: <span v-html="getServiceTime(selectedMethod)"></span></em> <br/>
                          <b-btn variant="success" class="mt-2 btn-sm" @click="showUpdateServiceTimeForm(selectedMethod)">Update Service Time</b-btn>
                        </template>
                        <template v-else>
                          <b-row>
                            <b-col sm="4" class="service-time">
                              <p-input v-model.trim="form.serviceTime.serviceFrom" name="serviceTime.serviceFrom" :handler="$v" :formData="form" type="time" />
                              <span class="mt-2 mx-2">TO</span>
                              <p-input v-model.trim="form.serviceTime.serviceTo" name="serviceTime.serviceTo" :handler="$v" :formData="form" type="time" />
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col sm="4" class="mt-2">
                              <b-btn variant="success" class="btn-sm" @click="set24Hours()">Enable 24 Hours</b-btn>
                              <b-btn variant="success" class="btn-sm" @click="updateServiceTime()">Save</b-btn>
                              <b-btn variant="danger" class="btn-sm" @click="closeUpdateServiceTimeForm()">Cancel</b-btn>
                            </b-col>
                          </b-row>
                        </template>
                      </template>
                    </b-col>
                    <b-col sm="3">
                      <div class="float-right" style="width: 300px">
                        <strong>Payment Status</strong>
                        <b-form-select v-if="checkAccessPrivilege('Payment.Level.Options.Change')" id="maintenanceStatus" :plain="true" :options="maintenanceOption" v-model="maintenanceStatus" text-field="label" value-field="key" @change="switchMaintenance()"></b-form-select>
                        <template v-else>
                          <b-badge v-if="selectedMethod.Maintenance === 0" variant="success">Enabled</b-badge>
                          <b-badge v-if="selectedMethod.Maintenance === 1" variant="danger">Maintenance</b-badge>
                        </template>
                      </div>
                    </b-col>
                  </b-row>
                </b-card-header>
                <b-card-body>
                  <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                    <template v-slot:cell(Status)="data">
                      <p-dropdown v-if="data.item._editable" v-model.trim="form.vipLevel.status" class="dropdown-select" name="vipLevel.status" :handler="$v" :formData="form" :options="statusOption" textKey="key" textValue="label"/>
                      <template v-else>
                        <b-badge variant="success" v-if="data.item.Status === 1">Enable</b-badge>
                        <b-badge variant="danger" v-else-if="data.item.Status === 0">Disable</b-badge>
                      </template>
                    </template>
                    <template v-slot:cell(Action)="data">
                      <template v-if="checkAccessPrivilege('Payment.Level.Options.Change')">
                        <template v-if="data.item._editable">
                          <b-btn class="btn-sm" @click="updateStatus(data.item)" variant="success"><i class="fa fa-check"></i> Save</b-btn>
                          <b-btn class="btn-sm" @click="cancelUpdateStatus(data.item)" variant="danger"><i class="fa fa-close"></i> Cancel</b-btn>
                        </template>
                        <template v-else>
                          <b-btn @click="showUpdateStatus(data.item)" class="btn-sm" variant="danger"><i class="fa fa-pencil"></i> Edit</b-btn>
                        </template>
                      </template>
                      <b-btn @click="showAddAttributesModel(data.item)" v-if="!data.item._editable && data.item.Status === 1 && selectedMethod.Attributes" class="btn-sm" variant="info"><i class="fa fa-pencil"></i>Payment Attributes</b-btn>
                    </template>
                  </b-table>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>

    <b-modal ref="showAddPaymentMethodModal" size="lg" header-bg-variant="primary" hide-footer title="Add Payment Method">
      <div class="mb-3">
        <label for="paymentGateway">Select Payment Gateway</label>
        <b-form-select id="paymentGateway" :plain="false" :options="paymentMethodModalData.paymentGateway" v-model="pgForm.paymentGateway" :state="$v.pgForm.paymentGateway.$error?false:null" @blur.native="$v.pgForm.paymentGateway.$touch" @change="getPaymentProviderList(pgForm.paymentGateway)">
          <template slot="first">
            <option :value="null">-- Please select an option --</option>
          </template>
        </b-form-select>
      </div>
      <div class="mb-3">
        <label for="payProvider">Select Payment Provider</label>
        <b-form-select id="payProvider" :plain="false" :options="paymentMethodModalData.payProvider" v-model="pgForm.payProvider" :state="$v.pgForm.payProvider.$error?false:null" @blur.native="$v.pgForm.payProvider.$touch" :disabled="!pgForm.paymentGateway">
          <template slot="first">
            <option :value="null">-- Please select an option --</option>
          </template>
        </b-form-select>
      </div>
      <div class="mb-3">
        <label for="payColor">Select Payment Color</label>
        <b-form-select id="payColor" :plain="false" :options="paymentMethodModalData.color" v-model="pgForm.payColor" :state="$v.pgForm.payColor.$error?false:null" @blur.native="$v.pgForm.payColor.$touch" :disabled="!pgForm.paymentGateway">
          <template slot="first">
            <option :value="null">-- Please select an option --</option>
          </template>
        </b-form-select>
      </div>
      <div class="mb-3">
        <b-button variant="success" @click="addPaymentMethod" :disabled="$v.pgForm.$invalid">Confirm</b-button>
        <b-button variant="outline-danger" @click="hideAddPaymentMethodModal">Cancel</b-button>
      </div>
    </b-modal>


    <attributes-modal v-if="showAttributesModal" :show-modal="showAttributesModal" :modal-data="attributesModalData" :access-right="checkAccessPrivilege('Payment.Level.Options.Attributes')" @closeModal="closeAttributesModal"/>

    <b-modal ref="featurePaymentConfirmModal" size="md" centered header-bg-variant="primary" hide-footer :title="isFeatured ? 'Remove Featured Payment' : 'Feature Payment'">
      <div class="d-block">
        <p>{{ isFeatured ? 'Are you sure you want to remove this payment method from featured?' : 'Are you sure you want to feature this payment method?' }}</p>
        <p><strong>Payment Method:</strong> {{ selectedMethod.Name }}</p>
      </div>
      <div class="mt-3">
        <b-button variant="success" @click="confirmFeaturePayment" class="mr-2">Confirm</b-button>
        <b-button variant="outline-danger" @click="hideFeaturePaymentConfirmModal">Cancel</b-button>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import moment from 'moment'
import VueNotifications from 'vue-notifications'
import AttributesModal from './AttributesModal'
import {PInput, PDropdown} from '../../../../components'
import {Events} from '../../../../events.js'
const {required} = require('vuelidate/lib/validators')
export default {
  name: 'vip-payment-option-list-view',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showAddPaymentMethodModel: false,
      showUpdateServiceTime: false,
      showAttributesModal: false,
      paymentMethodModalData: {
        paymentGateway: [],
        payProvider: [],
        color: [
          'red',
          'orange',
          'green',
          'cyan',
          'yellow',
          'blue',
          'secondary',
          'info',
          'primary',
          'success',
          'danger',
          'warning'
        ]
      },
      pgForm: {
        paymentGateway: '',
        payProvider: '',
        payColor: ''
      },
      updateData: {},
      items: [],
      paymentMethod: [],
      selectedMethod: {},
      attributesModalData: {},
      fields: [
        {key: 'Name', label: 'VIP Level'},
        {key: 'Status', label: 'Status'},
        {key: 'Action', label: 'Action'}
      ],
      form: {
        serviceTime: {
          serviceFrom: '',
          serviceTo: ''
        },
        vipLevel: {
          paymentId: '',
          levelId: '',
          status: null
        }
      },
      statusOption: [
        {key: 1, label: 'Enable'},
        {key: 0, label: 'Disable'}
      ],
      maintenanceStatus: 0,
      maintenanceOption: [
        {key: '0', label: 'Enabled'},
        {key: '1', label: 'Under Maintenance'}
      ]
    }
  },
  components: {
    PInput,
    PDropdown,
    AttributesModal
  },
  computed: {
    isFeatured () {
      if (!this.selectedMethod || !this.selectedMethod.Attributes) {
        return false
      }
      try {
        const attributes = typeof this.selectedMethod.Attributes === 'string'
          ? JSON.parse(this.selectedMethod.Attributes)
          : this.selectedMethod.Attributes
        return attributes && attributes.promote === true
      } catch (e) {
        // If Attributes is not valid JSON, check if it's an object directly
        if (typeof this.selectedMethod.Attributes === 'object') {
          return this.selectedMethod.Attributes.promote === true
        }
        return false
      }
    }
  },
  validations: {
    pgForm: {
      paymentGateway: { required },
      payProvider: { required },
      payColor: { required }
    },
    form: {
      serviceTime: {
        serviceFrom: {},
        serviceTo: {}
      },
      vipLevel: {
        paymentId: { required },
        levelId: { required },
        status: { required }
      }
    }
  },
  methods: {
    async addPaymentMethod () {
      try {
        Events.$emit('loader')
        await this.$http.post(this.API_ENDPOINT + '/payment/paymentMethod', this.pgForm, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Payment Method Added Successfully')
        this.hideAddPaymentMethodModal()
        this.getPaymentMethodList()
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async getPaymentProviderList (paymentGateway) {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + '/payment/paymentMethod/?paymentGateway=' + paymentGateway, { headers: { 'Content-Type': 'application/json' } })
        this.paymentMethodModalData.payProvider = data.payProvider
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async showAddPaymentMethodModal () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + '/payment/paymentMethod/', { headers: { 'Content-Type': 'application/json' } })
        this.paymentMethodModalData.paymentGateway = data.paymentGatewayList
        this.$refs.showAddPaymentMethodModal.show()
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    hideAddPaymentMethodModal () {
      this.$refs.showAddPaymentMethodModal.hide()
    },
    async selectMethod (val) {
      this.selectedMethod = val
      this.maintenanceStatus = val.Maintenance
      this.getVipMapList(val.Id)
      this.resetServiceTime()
    },
    resetServiceTime () {
      this.showUpdateServiceTime = false
      this.form.serviceTime.from = ''
      this.form.serviceTime.to = ''
      this.$v.form.serviceTime.$reset()
    },
    async getVipMapList (paymentId) {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.post(this.API_ENDPOINT + '/payment/levelmap/vip', { paymentId: paymentId }, { headers: { 'Content-Type': 'application/json' } })
        this.items = data.list
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async getPaymentMethodList () {
      try {
        let { data } = await this.$http.get(this.API_ENDPOINT + '/payment/paymentMethod/getList?type=1', { headers: { 'Content-Type': 'application/json' } })
        this.paymentMethod = data.list
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async updateStatus (item) {
      try {
        this.$v.form.vipLevel.$touch()
        if (this.$v.form.vipLevel.$error) {
          return true
        }
        Events.$emit('loader')
        let requestBody = {
          paymentId: this.form.vipLevel.paymentId,
          levelId: this.form.vipLevel.levelId,
          status: this.form.vipLevel.status
        }
        await this.$http.post(this.API_ENDPOINT + '/payment/levelmap/changestatus', requestBody, { headers: { 'Content-Type': 'application/json' } })
        await this.getVipMapList(this.form.vipLevel.paymentId)
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Status Update Successfully')
        this.cancelUpdateStatus(item)
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async switchMaintenance () {
      try {
        Events.$emit('loader')
        await this.$http.post(this.API_ENDPOINT + '/payment/paymentMethod/maintenance', {
          paymentId: this.selectedMethod.Id,
          status: this.maintenanceStatus
        })
        this.getPaymentMethodList()
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Payment Maintenace Status Changed Successfully.')
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    set24Hours () {
      this.form.serviceTime.serviceFrom = ''
      this.form.serviceTime.serviceTo = ''
      this.updateServiceTime()
    },
    async updateServiceTime () {
      try {
        Events.$emit('loader')
        const payload = {
          paymentId: this.selectedMethod.Id,
          from: this.form.serviceTime.serviceFrom,
          to: this.form.serviceTime.serviceTo
        }
        await this.$http.post(this.API_ENDPOINT + '/payment/paymentMethod/service-time/update', payload)
        this.selectedMethod.ServiceTimeFrom = this.form.serviceTime.serviceFrom
        this.selectedMethod.ServiceTimeTo = this.form.serviceTime.serviceTo
        this.resetServiceTime()
      } catch (err) {
        if (err.response.data.code === 'params.service.range.required') {
          Events.$emit('alert', VueNotifications.types.error, 'Error', err.response.data.msg)
        } else {
          console.log(err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      } finally {
        Events.$emit('loader')
      }
    },
    showAddAttributesModel (item) {
      this.showAttributesModal = true
      this.attributesModalData = {
        PaymentDetail: this.selectedMethod,
        ...item
      }
    },
    closeAttributesModal () {
      this.showAttributesModal = false
      this.attributesModalData = {}
      this.getVipMapList(this.selectedMethod.Id)
    },
    showUpdateServiceTimeForm (item) {
      this.showUpdateServiceTime = true
      this.form.serviceTime.serviceFrom = item.ServiceTimeFrom
      this.form.serviceTime.serviceTo = item.ServiceTimeTo
    },
    closeUpdateServiceTimeForm () {
      this.showUpdateServiceTime = false
      this.resetServiceTime()
    },
    getServiceTime (method) {
      if (!method.ServiceTimeFrom && !method.ServiceTimeTo) {
        return '24 Hours'
      }
      let from = moment(moment().format(`YYYY-MM-DD ${method.ServiceTimeFrom}`))
      let to = moment(moment().format(`YYYY-MM-DD ${method.ServiceTimeTo}`))
      let isNextDay = ''
      if (to.isBefore(from)) {
        isNextDay = 'Next Day'
      }
      return `${from.format('hh:mm A')} - <span style="color:red">${isNextDay}</span> ${to.format('hh:mm A')} (GMT+8)`
    },
    showUpdateStatus (item) {
      this.$set(item, '_editable', true)
      this.form.vipLevel.paymentId = this.selectedMethod.Id
      this.form.vipLevel.levelId = item.Id
      this.form.vipLevel.status = item.Status
    },
    cancelUpdateStatus (item) {
      this.$delete(item, '_editable')
      this.form.vipLevel.paymentId = ''
      this.form.vipLevel.levelId = ''
      this.form.vipLevel.status = null
    },
    checkAccessPrivilege (module) {
      if (!module) return true
      return this.PRIVILEGE.includes(module)
    },
    showFeaturePaymentConfirmModal () {
      if (Object.keys(this.selectedMethod).length === 0) {
        Events.$emit('alert', VueNotifications.types.warning, 'Warning', 'Please select a payment method first')
        return
      }
      this.$refs.featurePaymentConfirmModal.show()
    },
    hideFeaturePaymentConfirmModal () {
      this.$refs.featurePaymentConfirmModal.hide()
    },
    async confirmFeaturePayment () {
      try {
        Events.$emit('loader')
        const promoteValue = !this.isFeatured
        const payload = {
          paymentId: this.selectedMethod.Id,
          promote: promoteValue
        }
        await this.$http.post(this.API_ENDPOINT + '/payment/levelmap/promote', payload, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', VueNotifications.types.success, 'Success', promoteValue ? 'Payment method featured successfully' : 'Payment method removed from featured successfully')
        this.hideFeaturePaymentConfirmModal()
        // Refresh payment method list to update the state
        await this.getPaymentMethodList()
        // Re-select the current method to refresh its data
        const currentMethod = this.paymentMethod.find(m => m.Id === this.selectedMethod.Id)
        if (currentMethod) {
          this.selectMethod(currentMethod)
        }
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    }
  },
  created () {
    this.getPaymentMethodList()
  }
}
</script>

<style scoped>
.service-time {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/views/payment/viplevel/PaymentOption/VIPLevelPaymentListView.vue